import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";

const STORAGE_KEY = "bg_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6"
        >
          <div className="max-w-4xl mx-auto bg-[#141414] border border-[#C6A45D]/30 p-6 sm:p-8 shadow-2xl shadow-black">
            <p className="eyebrow mb-3 !text-[10px]">Privacy & Cookie</p>
            <p className="text-sm text-[#A5A5A5] font-light leading-relaxed">
              {t("cookie.text1")}
              <Link
                to="/privacy"
                data-testid="cookie-banner-privacy-link"
                className="text-[#C6A45D] hover:text-[#E5C776] underline underline-offset-4 transition-colors duration-300"
              >
                {t("cookie.policy")}
              </Link>
              .
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="px-7 py-3 bg-[#C6A45D] text-[#080808] text-xs tracking-[0.25em] uppercase font-semibold hover:bg-[#E5C776] transition-colors duration-300"
              >
                {t("cookie.accept")}
              </button>
              <button
                onClick={() => choose("essential")}
                data-testid="cookie-essential-button"
                className="px-7 py-3 border border-[#A5A5A5]/30 text-[#A5A5A5] text-xs tracking-[0.25em] uppercase hover:border-[#C6A45D] hover:text-[#C6A45D] transition-colors duration-300"
              >
                {t("cookie.essential")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
